import { render, staticRenderFns } from "./admin-article-editor.vue?vue&type=template&id=e5891746&scoped=true&"
import script from "./admin-article-editor.vue?vue&type=script&lang=js&"
export * from "./admin-article-editor.vue?vue&type=script&lang=js&"
import style0 from "./admin-article-editor.vue?vue&type=style&index=0&id=e5891746&prod&scoped=true&lang=css&"
import style1 from "./admin-article-editor.vue?vue&type=style&index=1&id=e5891746&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5891746",
  null
  
)

export default component.exports